export class ModalInputPopUpValidationsModel {
  public static createEmpty(): ModalInputPopUpValidationsModel {
    return new ModalInputPopUpValidationsModel();
  }
  constructor(
    public Regex: string = '',
    public ValidationMessage: string = '',
  ) { }
}

